import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import tenantReducer from './slices/tenantSlice';
import clusterReducer from './slices/clusterSlice';
import configReducer from './slices/configSlice';
import domainReducer from './slices/domainSlice';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import settingsReducer from './slices/settingsSlice';
import monitoringReducer from './slices/monitoringSlice';
import serviceConfigReducer from './slices/serviceConfigSlice';


const store = configureStore({
    reducer: {
        tenants: tenantReducer,
        clusters: clusterReducer,
        configs: configReducer,
        domains: domainReducer,
        auth: authReducer,
        ui: uiReducer,
        settings: settingsReducer,
        monitoring: monitoringReducer,
        serviceConfigs: serviceConfigReducer
    },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled', 'auth/logout/fulfilled'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.account'],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;